import { PostHogProvider} from 'posthog-js/react'
import { CONSTANTS } from '../../constants'
const options = {
  api_host: CONSTANTS.POSTHOG_HOST,
  autocapture: true,
  capture_pageview: true,
  session_recording: {
    enabled: false,
  }
}

const PostHogProviderContainer = ({children}) => {
  return (
    <PostHogProvider apiKey={CONSTANTS.POSTHOG_KEY} options={options}>{children}</PostHogProvider>
  )
}

export default PostHogProviderContainer